import type { ReactNode } from 'react'

import { IconBestMove } from '@gto/ui/assets'
import { Typography } from '@gto/ui/typography'

export const PromoOffersTips = ({ items }: { items: ReactNode[] }) => {
  return (
    <section className="flex flex-wrap gap-4">
      {items.map((tip, index) => (
        <article
          // eslint-disable-next-line @eslint-react/no-array-index-key -- tips are a fixed per-render ReactNode list; stateless; no scalar id
          key={index}
          className="flex flex-[1_0_30%] items-center gap-2 rounded-md border border-divider p-3 md:flex-[1_0_48%] sm:flex-[1_0_100%]"
        >
          <div className="text-primary-main">
            <IconBestMove
              height={20}
              width={20}
            />
          </div>

          <Typography variant="body1">{tip}</Typography>
        </article>
      ))}
    </section>
  )
}
